import React, { useState } from 'react'
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import Wrapper from '../../../../Common/Wrapper/Wrapper'
import useStyles from './FirmwareUpdate.style'
import { setFirmwareForUpdate } from '../../../../../actions/firmware'
import { convertFirmwareName } from '../../../../../helpers/convertFirmwareName'
import FirmwareUpdatePopup from './FirmwareUpdatePopup/FirmwareUpdatePopup'


const FirmwareUpdate = ({
  selectedMezzo, availableFirmwares, firmwareStatus,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [currentFirmware, setCurrentFirmware] = useState(null)
  const [firmwaresExpanded, setFirmwaresExpanded] = useState(false)
  const [isFirmwarePopupOpen, setIsFirmwarePopupOpen] = useState(false)

  return (
    <Wrapper className={classes.firmwareWrapper}>
      <Wrapper className={classes.selectWrapper}>
        <Typography className={classes.firmwareTitle}>Update Mezzo Firmware</Typography>
        <Accordion
          disabled={selectedMezzo.serial === 'N/A'}
          className={classes.firmwareButton}
          expanded={firmwaresExpanded}
          onClick={() => {
            if (selectedMezzo.serial !== 'N/A') {
              setFirmwaresExpanded(!firmwaresExpanded)
            }
          }}
        >
          <AccordionSummary
            className={classes.firmwareButtonSummary}
            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
          >
            <Typography className={classes.updateFirmware}>{currentFirmware || 'Select firmware version'}</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.firmwareDetails}>
            {availableFirmwares.length === 0 ? (
              <Wrapper className={classes.progressWrapper}>
                <Typography className={classes.firmwaresTip}>
                  No available firmwares.
                </Typography>
              </Wrapper>
            ) : (
              <List className={classes.firmwareList}>
                {availableFirmwares.map(firmware => (
                  <ListItem
                    key={firmware}
                    className={classes.firmwareVersion}
                    onClick={() => {
                      setCurrentFirmware(firmware)
                      dispatch(setFirmwareForUpdate(firmware))
                      setFirmwaresExpanded(false)
                      setIsFirmwarePopupOpen(true)
                    }}
                  >
                    {convertFirmwareName(firmware)}
                  </ListItem>
                ))}
              </List>
            )}
          </AccordionDetails>
        </Accordion>
      </Wrapper>
      {isFirmwarePopupOpen && (
        <FirmwareUpdatePopup
          setCurrentFirmware={setCurrentFirmware}
          firmwareStatus={firmwareStatus}
          setIsFirmwarePopupOpen={setIsFirmwarePopupOpen}
        />
      )}
    </Wrapper>
  )
}

FirmwareUpdate.propTypes = {
  selectedMezzo: PropTypes.shape({
    serial: PropTypes.string,
    identifier: PropTypes.string,
  }),
  availableFirmwares: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  firmwareStatus: PropTypes.shape({
    step: PropTypes.string,
    progress: PropTypes.number,
    totalProgress: PropTypes.number,
  }).isRequired,
}

FirmwareUpdate.defaultProps = {
  selectedMezzo: PropTypes.shape({
    serial: PropTypes.string,
    identifier: PropTypes.string,
  }),
}

export default FirmwareUpdate
